window.addEventListener('DOMContentLoaded', function () {
  //cart
  const isCartPage = location.pathname.includes('/cart');
  window.liquidAjaxCart.conf("updateOnWindowFocus", !isCartPage);
  liquidAjaxCart.conf("quantityTagDebounce", 0);
  document.addEventListener('liquid-ajax-cart:request-end', event => {
    if (document.querySelector('.variation')) {
      var variation = new Splide('.variation', {
        type: 'slide',
        pagination: false,
        arrows: false,
        perPage: '2.2',
        autoWidth: true,
        padding: { right: 25 },
        drag: document.querySelector('.variation .splide__list').childElementCount > 2 ? true : false,
        gap: '10px',
        isNavigation: true,
      });
      var variation_cart = new Splide('.variation-cart', {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false,
        drag: false
      });
      variation_cart.sync( variation );
      variation_cart.mount();
      variation.mount();
    }
    const {requestState} = event.detail;
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      document.querySelector('#cart_modal')?.setAttribute('aria-expanded', 'true');
      if (window.upsell) {
        upsell.Components.Move.jump(0);
        upsell.Components.Controller.setIndex(0, false);
        upsell.refresh();
      }
    }
  });

  //lazy load
  const items = document.querySelectorAll('.item');
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('is-view');
        }, index * 100);
        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0
  });
  items.forEach(item => observer.observe(item));

  //language select
  document.querySelectorAll('.language_select').forEach(select => {
    select.addEventListener('change', function () {
      if (this.value !== '') {
        window.location.href = this.value;
      }
    });
  });

  //contents header
  const header = document.querySelector('.contents_header');
  if (header) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        header.classList.toggle('is-fixed', !entry.isIntersecting);
      },
      {
        rootMargin: '-45px 0px 0px 0px',
        threshold: 0
      }
    );

    const marker = document.createElement('div');
    marker.style.height = '1px';
    header.before(marker);

    observer.observe(marker);
    window.addEventListener('scroll', () => {
      const scrollMenu = window.scrollY;
      document.querySelectorAll('.contents_list li[id], .limited_contents li[id]').forEach(function (section) {
        const top = section.offsetTop - 100;
        const height = section.offsetHeight;
        const id = section.getAttribute('id');
        const nav = document.querySelector(`.contents_header a[href="#${id}"]`);
        if (nav && scrollMenu >= top && scrollMenu < top + height) {
          const current = document.querySelector('.contents_header a.active');
          if (current !== nav) {
            if (current) current.classList.remove('active');
            nav.classList.add('active');
          }
        }
      });
    });
  }

  //side menu
  document.querySelector(".header_inner .menu").addEventListener('click', function () {
    document.querySelector("#shopify-section-menu").classList.add("open");
  });
  document.querySelector("#menu .close").addEventListener('click', function () {
    document.querySelector("#shopify-section-menu").classList.remove("open");
  });
  document.querySelector("#shopify-section-menu").addEventListener('click', function (e) {
    if (!e.target.closest("#menu")) {
      document.querySelector("#shopify-section-menu").classList.remove("open");
    }
  });

  if (!location.hash && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    const href = link.getAttribute('href');
    if (href === '#gift' || href === '#pointgift' || href === "#recover") return; 
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href').slice(1);
      const targetEl = document.getElementById(targetId);
      if (targetEl) {
        e.preventDefault();
        targetEl.scrollIntoView();
        history.replaceState(null, '', window.location.pathname);
      }
    });
  });

  //header news
  if (document.getElementsByClassName("news_ticker").length > 0) {
    new Splide('.news_ticker', {
      type: 'fade',
      role: 'region',
      rewind: true,
      perPage: 1,
      height: "30px",
      autoplay: true,
      interval: 4000,
      speed: 2000,
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
      arrows: false
    }).mount();
  }

  //top slide
  if (document.querySelector('.top .splide')) {
    const firstSlide = document.querySelector('.top .splide .splide__slide');
    const hero = new Splide('.top .splide', {
      label: 'top',
      type: 'loop',
      role: 'region',
      perPage: 1,
      perMove: 1,
      autoplay: true,
      interval: firstSlide?.dataset.splideHtmlVideo ? 15000 : 6000,
      speed: 600,
      drag: document.querySelector('.top .splide .splide__list').childElementCount > 1,
      snap: true,
      pagination: true,
      arrows: false,
      pauseOnHover: true,
      pauseOnFocus: false,
      flickPower: 200,
      lazyLoad: false,
      video: {
        mute: true,
        hideControls: true,
        loop: true,
        autoplay: true,
        playsinline: true,
        disableOverlayUI: true,
        playerOptions: {
          htmlVideo: {
            playsInline: true,
            autoplay: true
          }
        }
      }
    });

    hero.on('mounted move', () => {
      const current = hero.Components.Slides.getAt(hero.index).slide;
      hero.root.classList.toggle('is-dark', current.classList.contains('theme-dark'));
    });
    hero.on('inactive', (slide) => {
      const video = slide.slide.querySelector('video');
      if (video) {
        video.currentTime = 0;
      }
    });
    window.addEventListener('pageshow', () => {
      hero.Components.Video.disable(false);
      hero.Components.Autoplay.play();
      const current = hero.Components.Slides.getAt(hero.index).slide;
      const video = current.querySelector('video');
      if (video) {
        video.play().catch(() => {});
      }
    });
  
    hero.mount(window.splide.Extensions);
    /* hero.Components.Video.disable( true ); */
  }

  //top product
  if (document.getElementsByClassName("top_product").length > 0) {
    new Splide('.top_product .splide', {
      type: 'loop',
      role: 'none',
      drag: true,
      autoplay: true,
      interval: 4000,
      speed: 600,
      arrows: false,
      pagination: false,
      perPage: 5,
      perMove: 1,
      flickMaxPages: 1,
      flickPower: 200,
      focus: 'center',
      breakpoints: {
        800: {
          perPage: 3,
          perMove: 1,
        },
        640: {
          perPage: 2,
          perMove: 1,
        }
      }
    }).mount();
  }
  //what oil
  function voice() {
    var elms = document.getElementsByClassName("voice");
    for (var i = 0; i < elms.length; i++) {
      new Splide(elms[i], {
        type: 'loop',
        role: 'region',
        rewind: true,
        speed: 600,
        drag: true,
        arrows: false,
        pagination: true,
        autoplay: true,
        interval: 5000,
        perPage: 2,
        perMove: 1,
        gap: '12px',
        breakpoints: {
          767: {
            perPage: 1,
            focus: 'center',
            padding: "10%"
          }
        }
      }).mount();
    }
  }
  voice();

  //limited
  if (document.getElementById("limited") != null) {
    new Splide('#limited .splide', {
      type: document.querySelector('#limited .splide .splide__list').childElementCount > 2 ? 'loop' : 'slide',
      role: 'none',
      rewind: true,
      autoplay: true,
      interval: 4000,
      speed: 600,
      rewindByDrag: true,
      drag: document.querySelector('#limited .splide .splide__list').childElementCount > 1,
      pagination: true,
      arrows: false,
      perPage: document.querySelector('#limited .splide .splide__list').childElementCount > 1 ? 2 : 1,
      perMove: document.querySelector('#limited .splide .splide__list').childElementCount > 1 ? 2 : 1,
      gap: 0,
      gap: document.querySelector('#limited .splide .splide__list').childElementCount > 1 ? '20px' : '0',
      breakpoints: {
        800: {
          perPage: 2,
          perMove: 1
        },
        640: {
          perPage: 1,
          perMove: 1
        }
      }
    }).mount();
  }
  // product
  function product() {
    var elms = document.getElementsByClassName("product_image");
    for (var i = 0; i < elms.length; i++) {
      new Splide(elms[i], {
        type: document.querySelector('.product_image .splide__list').childElementCount > 1 ? 'loop' : 'slide',
        loop: document.querySelector('.product_image .splide__list').childElementCount > 1,
        role: 'none',
        rewind: true,
        rewindByDrag: true,
        speed: 600,
        drag: document.querySelector('.product_image .splide__list').childElementCount > 1 ? true : false,
        arrows: false,
        pagination: true,
        perPage: 1,
        video: {
          mute: true,
          hideControls: true,
          loop: true,
          autoplay: true,
          playsinline: true,
          disableOverlayUI: true,
          playerOptions: {
            htmlVideo: {
              playsInline: true,
              autoplay: true
            }
          }
        }
      }).mount(window.splide.Extensions);
    }
  }
  product();

  // variation
  if (document.querySelector('.variation')) {
    document.querySelectorAll('.limited_set, li[id^="set"]').forEach((item) => {
      const variationEl = item.querySelector('.variation');
      const variationCartEl = item.querySelector('.variation-cart');
      const variationMainEl = item.querySelector('.variation-main');
      if (!variationEl || !variationCartEl) return;
      var variation = new Splide(variationEl, {
        type: 'slide',
        pagination: false,
        arrows: false,
        perPage: '2.2',
        autoWidth: true,
        drag: variationEl.querySelector('.splide__list').childElementCount >= 3 ? true : false,
        gap: '10px',
        isNavigation: true,
        focus: false
      });
      var variation_cart = new Splide(variationCartEl, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false,
        drag: false
      });
      if (variationMainEl) {
        var variation_main = new Splide(variationMainEl, {
          type: 'fade',
          rewind: true,
          pagination: false,
          arrows: false,
          drag: false
        });
        variation_main.sync(variation);
        variation_main.mount();
        variation_main.on('move', (newIndex, prevIndex) => {
          const prevSlide = variation_main.Components.Elements.slides[prevIndex];
          const nextSlide = variation_main.Components.Elements.slides[newIndex];
          if (!prevSlide || !nextSlide) return;
          const prevDetails = prevSlide.querySelectorAll('.set_inner details');
          const nextDetails = nextSlide.querySelectorAll('.set_inner details');
          prevDetails.forEach((details, index) => {
            if (nextDetails[index]) {
              nextDetails[index].open = details.open;
            }
          });
          const prevToggle = prevSlide.querySelector('.accordion_toggle');
          const nextToggle = nextSlide.querySelector('.accordion_toggle');
          if (prevToggle && nextToggle) {
            nextToggle.checked = prevToggle.checked;
          }
        });
      }
      variation_cart.sync(variation);
      variation_cart.mount();
      variation.mount();
    });
  }
  // bundle set
  if (document.querySelector('.bundle_image')) {
    var bundle_variation = new Splide('.bundle .variation', {
      type: 'slide',
      pagination: false,
      arrows: false,
      perPage: '2.2',
      autoWidth: true,
      drag: document.querySelector('.bundle .variation .splide__list').childElementCount >= 3 ? true : false,
      gap: '10px',
      isNavigation: true,
      focus: false
    });
    var bundle_main = new Splide('.bundle .variation-main', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
      drag: false
    });
    var bundle_cart = new Splide('.bundle .variation-cart', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
      drag: false
    });
    var bundle = new Splide('.bundle_image', {
      type: 'slide',
      role: 'none',
      rewind: true,
      rewindByDrag: true,
      speed: 600,
      drag: true,
      arrows: false,
      pagination: true,
      perPage: 1,
      isNavigation: true
    });
    bundle_main.mount();
    bundle_cart.mount();
    bundle.mount();
    bundle_variation.mount();
    bundle_main.sync(bundle);
    bundle_cart.sync(bundle);
    bundle_variation.sync(bundle);
  }
  
  // upsell modal
  if (document.querySelector('.upsell')) {
    window.upsell = new Splide('.upsell', {
      type: 'loop',
      role: 'none',
      rewind: true,
      interval: 4000,
      speed: 600,
      arrows: false,
      lazyLoad: 'sequential',
      pagination: true,
      perPage: 1,
      autoplay: true
    }).mount();
  }
  document.addEventListener('click', function (e) {
    const cartModal = document.querySelector('#cart_modal');
    const cartContent = cartModal?.querySelector('.modal_content');
    const isCartOpen = cartModal?.getAttribute('aria-expanded') === 'true';
    const isCloseBtn = e.target.closest('.btn-close');
    if (isCartOpen && (!cartContent.contains(e.target) || isCloseBtn)) {
      cartModal.setAttribute('aria-expanded', 'false');
    }
  });

  // fixed button
  window.addEventListener('scroll', () => {
    const cartBar = document.querySelector('#cart_bar');
    const saleBar = document.querySelector('.is-active + .sale_bar');
    const contents = document.querySelector('.product_contents, .limited');
    if (cartBar || saleBar) {
      const scrollTop = window.scrollY;
      const windowBottom = scrollTop + window.innerHeight;
      const contentsBottom = contents.getBoundingClientRect().bottom + scrollTop;
      if (scrollTop > 750 && windowBottom < contentsBottom) {
        if (saleBar) {
          saleBar.classList.add('fixed');
        } else {
          cartBar.classList.add('fixed');
        }
      } else {
        if (saleBar) {
          saleBar.classList.remove('fixed');
        } else {
          cartBar.classList.remove('fixed');
        }
      }
    }
  });
  document.addEventListener('click', (e) => {
    const button = e.target.closest('#cart_bar .select_option');
    if (!button) return;
    const section = document.querySelector('section.product');
    if (!section) return;
    const rect = section.getBoundingClientRect();
    const target = window.scrollY + rect.bottom - window.innerHeight;
    window.scrollTo({
      top: target,
      behavior: 'smooth'
    });
    e.target('#cart_bar').classList.remove('fixed');
  });
  const updateFixedBars = () => {
    document.querySelectorAll('.fixed_bar').forEach((fixedBar) => {
      const set = fixedBar.closest('[id^="set"]');
      if (!set) return;
      if (fixedBar.dataset.scrolling === 'true') {
        return;
      }
      const hasOpenDetails = set.querySelector('.set_inner details[open]');
      const setRect = set.getBoundingClientRect();
      const setReachedTop = setRect.top <= 0;
      const setPassedBottom = setRect.bottom <= window.innerHeight + 1;
      if (hasOpenDetails && setReachedTop && !setPassedBottom) {
        fixedBar.classList.add('fixed');
      } else {
        fixedBar.classList.remove('fixed');
      }
    });
  };
  window.addEventListener('scroll', updateFixedBars);
  document.querySelectorAll('.set_inner details').forEach((details) => {
    details.addEventListener('toggle', updateFixedBars);
  });
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.fixed_bar .select_option');
    if (!button) return;
    const fixedBar = button.closest('.fixed_bar');
    const set = button.closest('[id^="set"]');
    if (!fixedBar || !set) return;
    const rect = set.getBoundingClientRect();
    const target = window.scrollY + rect.bottom - window.innerHeight;
    fixedBar.dataset.scrolling = 'true';
    window.scrollTo({
      top: target,
      behavior: 'smooth'
    });
    window.addEventListener('scrollend', () => {
      fixedBar.dataset.scrolling = 'false';
      fixedBar.classList.remove('fixed');
    }, { once: true });
  });

  //review
  document.querySelectorAll('.mxpr-review__list-item-body-conent').forEach(el => {
    const fullText = el.innerHTML;
    const maxLength = 150;
    if (fullText.length > 200) {
      const showText = fullText.substring(0, maxLength);
      const hideText = fullText.substring(maxLength);
  
      el.innerHTML = `
        ${showText}<span class="hide" style="display: none;">${hideText}</span>
        <a class="more" href="#">... 続きを読む</a>
      `;
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.matches('.mxpr-review__list-item-body-conent .more')) {
      e.preventDefault();
      const moreLink = e.target;
      const hiddenText = moreLink.previousElementSibling;
      if (hiddenText && hiddenText.classList.contains('hide')) {
        hiddenText.style.display = 'inline';
        moreLink.style.display = 'none';
      }
    }
  });

  // howto
  if (document.getElementsByClassName("howto_list").length > 0) {
    document.querySelectorAll('.howto_list .splide').forEach((howto) => {
      new Splide(howto, {
        type: document.querySelector('.howto_list .splide__list').childElementCount > 1 ? 'loop' : 'slide',
        loop: document.querySelector('.howto_list .splide__list').childElementCount > 1,
        perPage: 1,
        pagination: true,
        arrows: false,
      }).mount();
    });
  }

  //video
  if (document.querySelectorAll('.plyr').length > 0) {
    document.querySelectorAll('.plyr').forEach((el) => {
      const player = new Plyr(el, {
        controls: ['play-large', 'mute', 'progress'],
        loop: { active: false },
        clickToPlay: true,
        hideControls: false,
        fullscreen: {
          enabled: false
        },
      });
      player.muted = false;
    });
  }
  if (document.querySelectorAll("#youtube").length > 0) {
    const player = new Plyr('#youtube', {
      controls:['play-large', 'mute', 'progress'],
      youtube: {
        rel: 0,
        noCookie: true,
        controls: 0
      },
      loop: { active: false },
      clickToPlay: true,
      hideControls: false,
      fullscreen: {
        enabled: false
      },
     });
     player.muted = false;
  }

  //blog
  let counter = 1;
  const headings = document.querySelectorAll('.column_content h2');
  const topics = headings.length;

  if (topics > 2) {
    const summary = document.querySelector('.column_summary');
    const topicsWrapper = document.createElement('div');
    topicsWrapper.className = 'topics';
    topicsWrapper.innerHTML = '<h3>topics</h3><ul class="topics_list"></ul>';
    summary.insertAdjacentElement('beforeend', topicsWrapper);

    const topicsList = topicsWrapper.querySelector('.topics_list');

    headings.forEach(heading => {
      const topicId = 'topic' + counter;
      heading.id = topicId;

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + topicId;
      a.textContent = heading.textContent;

      li.appendChild(a);
      topicsList.appendChild(li);

      counter++;
    });
  }

  //copy
  document.body.addEventListener('click', (e) => {
    const target = e.target.closest('.copy_code, .vip-app-referral-code-block_code');
    if (!target) return;

    const coupon = target.textContent.trim();
    navigator.clipboard.writeText(coupon).then(() => {
      target.classList.add("copied");
      setTimeout(() => {
        target.classList.remove("copied");
      }, 4000);
    });
  });

  //input
  document.querySelectorAll('.form input').forEach((input, index, inputs) => {
    let isComposing = false;
    input.addEventListener('compositionstart', () => {
      isComposing = true;
    });
    input.addEventListener('compositionend', () => {
      isComposing = false;
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !isComposing) {
        e.preventDefault();
        const allInputs = Array.from(document.querySelectorAll('.form input'));
        const currentIndex = allInputs.indexOf(this);
        const nextIndex = currentIndex + 1;
        if (nextIndex < allInputs.length) {
          allInputs[nextIndex].focus();
        } else {
          this.blur();
        }
      }
    });
  });
  document.querySelectorAll('.input_limit input').forEach(input => {
    input.addEventListener('compositionend', handleConvert);
    input.addEventListener('blur', handleConvert);
  
    handleConvert();
  
    function handleConvert() {
      let str = input.value;
      str = str.replace(/[A-Za-z0-9-!"#$%&'()=<>,.?_\[\]{}@^~\\]/g, s => {
        return String.fromCharCode(s.charCodeAt(0) + 65248);
      });
      const beforeStr = ['ｧ','ｨ','ｩ','ｪ','ｫ','ｬ','ｭ','ｮ','ｯ','ｰ','ｳﾞ','ｶﾞ','ｷﾞ','ｸﾞ','ｹﾞ','ｺﾞ','ｻﾞ','ｼﾞ','ｽﾞ','ｾﾞ','ｿﾞ','ﾀﾞ','ﾁﾞ','ﾂﾞ','ﾃﾞ','ﾄﾞ','ﾊﾞ','ﾋﾞ','ﾌﾞ','ﾍﾞ','ﾎﾞ','ﾊﾟ','ﾋﾟ','ﾌﾟ','ﾍﾟ','ﾎﾟ','ｱ','ｲ','ｳ','ｴ','ｵ','ｶ','ｷ','ｸ','ｹ','ｺ','ｻ','ｼ','ｽ','ｾ','ｿ','ﾀ','ﾁ','ﾂ','ﾃ','ﾄ','ﾅ','ﾆ','ﾇ','ﾈ','ﾉ','ﾊ','ﾋ','ﾌ','ﾍ','ﾎ','ﾏ','ﾐ','ﾑ','ﾒ','ﾓ','ﾔ','ﾕ','ﾖ','ﾗ','ﾘ','ﾙ','ﾚ','ﾛ','ﾜ','ｦ','ﾝ'];
      const afterStr  = ['ァ','ィ','ゥ','ェ','ォ','ャ','ュ','ョ','ッ','ー','ヴ','ガ','ギ','グ','ゲ','ゴ','ザ','ジ','ズ','ゼ','ゾ','ダ','ヂ','ヅ','デ','ド','バ','ビ','ブ','ベ','ボ','パ','ピ','プ','ペ','ポ','ア','イ','ウ','エ','オ','カ','キ','ク','ケ','コ','サ','シ','ス','セ','ソ','タ','チ','ツ','テ','ト','ナ','ニ','ヌ','ネ','ノ','ハ','ヒ','フ','ヘ','ホ','マ','ミ','ム','メ','モ','ヤ','ユ','ヨ','ラ','リ','ル','レ','ロ','ワ','ヲ','ン'];
  
      beforeStr.forEach((s, i) => {
        str = str.replace(new RegExp(s, 'g'), afterStr[i]);
      });
  
      input.value = str;
      const txtcount = input.value.length;
      const counter = input.nextElementSibling;
      if (counter && counter.classList.contains('limit_num')) {
        counter.textContent = txtcount;
      }
      if (txtcount >= 16) {
        input.parentElement.classList.add('error');
      } else {
        input.parentElement.classList.remove('error');
      }
    }
  });
  function initFormValidation() {
    const buttons = document.querySelectorAll('.form input[type="button"]');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const form = btn.closest('form');
        let isRequired = 0;
        const fields = form.querySelectorAll('input[required], .input_limit input[required], select[required]');
        fields.forEach(field => {
          const val = field.value;
          const selected = field.tagName === 'SELECT' ? field.options[field.selectedIndex].value : val;
          if (!selected) {
            field.style.boxShadow = '0 0 0 1px #b93636';
            window.scrollTo({ top: 50, behavior: 'smooth' });
            isRequired++;
          } else {
            field.removeAttribute('style');
          }
        });
        if (isRequired === 0) {
          form.submit();
        } else {
          const errorBox = form.parentElement.querySelector('.required_error');
          if (errorBox && !errorBox.querySelector('.error_form')) {
            const p = document.createElement('p');
            p.className = 'error_form';
            p.textContent = '必ず入力してください';
            errorBox.appendChild(p);
            errorBox.style.display = 'block';
          }
        }
      });
    });
  }
  initFormValidation();
});